import { createUserInfoSource } from '@forest/paywall-core'
import { native, type UserInfo } from '@forest/native-services'
import { shouldMockAPI } from '~/lib/params'

export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (import.meta.env.DEV && shouldMockAPI) {
      return {
        user_type: 'legacy',
        user_id: 1,
        server: 'staging',
        token: 'mock_token',
      } satisfies UserInfo
    }
    const result = await native.user.getUserInfo()
    if (!result.success || !result.data) {
      throw new Error('Failed to get user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) throw new Error('Failed to refresh token')
    return result.data
  },
})

export const $userInfo = userInfoSource.atom
